<template>
  <div class="questionByScenic">
    <div class="navTitle">
      <van-nav-bar
        title="问答"
        right-text="我的问答"
        left-arrow
        @click-right="MyQuestion()"
        @click-left="onClickLeft"
      />
    </div>

    <div class="title">
      {{ title }}<span id="questionNumber">共{{ total }}个问题</span>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="loadData"
    >
      <van-cell
        v-for="item in list"
        :key="item.id"
        @click="QuestionDetail(item)"
      >
        <div class="questionInfo">
          <div class="left">
            <img :src="questionIcon" alt="" />
          </div>
          <div class="questionMessage">
            <div class="questionTitle">{{ item.title }}</div>
            <div class="ask">{{ item.answer_content }}</div>
          </div>
        </div>
        <div class="questionNumber">
          <span>全部{{ item.answers }}条回答</span>
          <van-image class="arrow" :src="arrowRight"></van-image>
        </div>
      </van-cell>
    </van-list>
    <div class="footerView">
      <van-button @click="IWantQuestion">我要提问</van-button>
    </div>
    <div class="nodata" v-if="total == 0" style="text-align:center">
      <div>
        <van-image
          :src="noDataIcon"
          width="200px"
          height="200px"
          fit="contain"
        ></van-image>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  data() {
    return {
      arrowRight: require("../../assets/iconImage/arrow_lightgray.png"),
      questionIcon: require("../../assets/iconImage/ic-ask-question.png"),
      noDataIcon: require("../../assets/iconImage/no_data@2x.png"), // 回答
      title: "",
      sid: "",
      stype: "",
      list: [],
      loading: false,
      finished: true,
      total: 1,
      page: 0,
      pageSize: 10,
      toastTitle: "没有任何内容，快去提问吧",
    };
  },
  created() {
    window.wii.app.invoke("showNativeBar", false);
    this.sid = this.$route.query.sid;
    this.stype = this.$route.query.stype;
    this.title = this.$route.query.title;
    this.loadData();
  },
  methods: {
    loadData() {
      this.page += 1;
      var params = {
        sid: this.sid,
        page: this.page,
        page_size: this.pageSize,
      };
      this.$http
        .post(`/appserver/v1/quesAnswer/getAllList`, qs.stringify(params), {
          headers: {
            "Set-Cookie": `w_uid=${this.uid};w_open_id=${this.open_id};w_skey=${this.skey}`,
          },
        })
        .then((data) => {
          if (data.data.ret == 0) {
            var response = data.data.data;
            this.list = response.list;
            // eslint-disable-next-line no-console
            console.log(this.list);
            this.total = response.pagination.total;
          }else{
            this.total = 0;
          }
        });
    },
    onClickLeft() {
      window.wii.app.invoke("closeWindow");
    },

    MyQuestion() {
      if (!this.uid) {
        window.wii.app.invoke("login", {
          callback: "",
        });
      }
      else{
        this.$router.push({
          path: "/MyQuestion",
          query: {
            isFromWeb: true,
          },
        });
      }
    },
    IWantQuestion() {
      if (!this.uid) {
        window.wii.app.invoke("login", {
          callback: "",
        });
      }
      else{
        this.$router.push({
          path: "/IWantQuestion",
          query: {
            sid: this.sid,
            stype: this.stype,
            isFromWeb: true,
          },
        });
      }

    },
    QuestionDetail(item) {
      this.$router.push({
        path: "/QuestionDetails",
        query: {
          id: item.id,
          sid: this.sid,
          stype: this.stype,
          from: true
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.empty {
  margin-top: 44px;
}
.van-list {
  margin-top: 10px;
  padding: 0px 15px;
  /deep/ .van-cell {
    margin: 15px 0px;
    border-radius: 4px;
  }
}
.navTitle {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 1800;
  border-bottom: 1px solid #f1f4f1;
  /deep/ .van-nav-bar {
    width: 100%;
  }
  /deep/ .van-nav-bar .van-icon {
    color: #000;
    font-size: 22px;
    font-weight: 600;
  }
  >>> .van-nav-bar .van-icon {
    color: #000;
    font-size: 22px;
    font-weight: 600;
  }
  /deep/ .van-nav-bar__title {
    font-size: 17px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #262626;
  }
  /deep/ .van-nav-bar__text {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2eba73;
  }
  /deep/ .van-nav-bar__text:active {
    background: #fff;
  }
  /deep/ .van-hairline--bottom::after {
    border: 0px;
  }
}
.questionByScenic {
  background-color: #f4f1f4;
  height: 100%;
}
.title {
  background-color: white;
  font-size: 17px;
  color: #000000;
  padding: 20px;
  padding-top: 66px;
  line-height: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
#questionNumber {
  color: #bfbfbf;
  font-size: 13px;
  margin-left: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.questionList {
  padding-bottom: 70px;
}
.questionCell {
  background-color: white;
  margin: 15px;
  padding: 15px 15px 0px 15px;
}
.questionInfo {
  display: flex;
  justify-content: flex-start;
  padding-bottom: 10px;
  border-bottom: 0.5px solid #f4f1f4;
}
.left {
  padding-top: 3px;
}
.questionMessage {
  width: 100%;
  margin-left: 5px;
  font-size: 16px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.ask {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #787878;
  margin-top: 10px;
  bottom: 10px;
}
.questionNumber {
  padding-top: 10px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  padding-left: 20px;
  display: inline-flex;
  line-height: 18px;
  color: rgba(0, 0, 0, 0.25);
  .arrow {
    width: 20px;
    height: 20px;
    // top: -2px;
  }
}
.footerView {
  width: 100%;
  height: 72px;
  padding: 15px 25px;
  box-sizing: border-box;
  flex: 0 0 auto;
  box-shadow: 1px 0px 10px #ddd;
  z-index: 1200;
  position: fixed;
  bottom: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  /deep/ .van-button {
    width: 100%;
    height: 100%;
    color: #fff;
    font-size: 15px;
    background-color: #30b876;
    border-radius: 4px;
  }
}
.noData {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
  margin-top: 50px;
  text-align: center;
  & > div {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;
    p {
      width: 100%;
      text-align: center;
      margin-top: 19px;
      font-size: 14px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: rgba(155, 155, 155, 1);
    }
  }
  /deep/ .van-button {
    margin-top: 100px;
    width: 100%;
    border: 0px;
    height: 40px;
  }
  /deep/ .van-button span {
    font-size: 17px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }
}
</style>
